import editor from "./editor";
import mediaQueries from "./media-queries";

const wrapper = {
  ...editor.wrapper,
  [mediaQueries.tablet]: {
    margin: "60px auto 0 auto"
  }
};

const title = {
  ...editor.title,
  [mediaQueries.desktop]: {
    ...editor.title[mediaQueries.desktop],
    maxWidth: "500px",
    margin: "0 auto",
    width: "auto"
  }
};

const rightCol = {
  ...editor.rightCol,
  maxWidth: "305px",
  [mediaQueries.desktop]: {
    ...editor.rightCol[mediaQueries.desktop],
    paddingTop: "90px"
  }
};

const previewWrapper = {
  marginLeft: "-15px",
  marginRight: "-15px",
  [mediaQueries.tablet]: {
    width: "73.5%",
    margin: "55px auto 0 auto",
    display: "block"
  }
};

const preview = {
  ...editor.preview,
  border: "2px solid #D5C17D",
  paddingTop: "calc(33% - 4px)" //image aspect ratio - border
};

const selected = {
  width: "100%",
  height: "auto",
  position: "absolute",
  top: "50%",
  left: 0,
  transform: "translateY(-50%)"
};

const flexList = {
    listStyleType: "none",
    padding: "0",
    marginBottom: "32px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    [mediaQueries.tablet]: {
        justifyContent: "space-between"
    }
};

const flexItem = {
  position: "relative",
  cursor: "pointer",
  marginLeft: "5px",
  marginRight: "5px"
};

const pageContainer = {
    width: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    [mediaQueries.tablet]: {
        maxWidth: '530px'
    }
};

const contentContainer = {
    width: "80%",
    margin:"15px auto 0 auto",

    [mediaQueries['tablet']]: {
        width: "100%",
        margin: "15px 0 0 0"
    }
}

export default {
  wrapper,
  title,
  rightCol,
  previewWrapper,
  preview,
  selected,
  flexList,
  flexItem,
  pageContainer,
  contentContainer
};



// WEBPACK FOOTER //
// ./src/styles/background.js